import { Granularity } from 'modules/charts/HashrateChart';
import { IdType } from 'types/common';

export const publicUrls = {
  main: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  newPassword: '/new-password',

  profile: '/profile',

  banners: '/banners',
  notifications: '/notifications',

  rootAdmin: {
    admins: '/root-admin/admins',
    billing: '/root-admin/billing',
    partnerSchemes: '/root-admin/partner-schemes',
    recalculation: '/root-admin/recalculation',
  },

  users: {
    main: '/users',
    withBtcHashrate: '/users/btc-hashrate',

    applications: {
      main: '/users/applications',
      vip: '/users/applications/vip',
      betaTest: '/users/applications/beta-test',
    },
  },

  accounts: {
    main: '/accounts',
  },
};

const API_PREFIX = '/adm/api/v1';

export const apiUrls = {
  auth: {
    login: `${API_PREFIX}/login`,
    login2fa: `${API_PREFIX}/login2fa`,
    loginRecovery: `${API_PREFIX}/login/otp`,
    logout: `${API_PREFIX}/logout`,
    refresh: `${API_PREFIX}/refresh`,
    currentUser: `${API_PREFIX}/admin/profile`,

    twoFa: `${API_PREFIX}/admin_user/2fa`,
    disableTwoFa: `${API_PREFIX}/admin_user/2faoff`,
    changePassword: `${API_PREFIX}/admin_user/password/change`,

    resetPasswordLink: `${API_PREFIX}/admin/reset`,
    token: `${API_PREFIX}/admin/token`,
  },

  admin: {
    all: `${API_PREFIX}/admins`,
    main: `${API_PREFIX}/admin/`,
    invite: `${API_PREFIX}/admin/invite`,
  },

  dashboard: {
    workersNumber: `${API_PREFIX}/account/stats/workers_number`,
    dailyHashrateAndProfit: `${API_PREFIX}/account/table/daily_hashrate_and_profit`,
    hashrateStats: `${API_PREFIX}/account/stats/hashratestats`,
    balance: `${API_PREFIX}/account/balance`,
    profitChart: `${API_PREFIX}/account/profit_chart`,
    networkStats: `${API_PREFIX}/landing/infobar`,

    accountsSummary: (uid: IdType) => `${API_PREFIX}/user/${uid}/accounts_summary`,
    hashrateChart: (column: Granularity) => `${API_PREFIX}/account/stats/${column}`,
  },

  users: {
    all: `${API_PREFIX}/users`,
    vipApplications: `${API_PREFIX}/vipapplications`,
    betaTestApplications: `${API_PREFIX}/demo_applications`,
    search: `${API_PREFIX}/search/users`,

    byUid: (uid: IdType) => `${API_PREFIX}/user/${uid}`,
    walletByUid: (uid: IdType) => `${API_PREFIX}/user/${uid}/wallet`,
    btcMiningByUid: (uid: IdType) => `${API_PREFIX}/user/${uid}/btcmining`,
    apiById: (uid: IdType) => `${API_PREFIX}/user/${uid}/api_settings`,
    paymentSettingsById: (uid: IdType) => `${API_PREFIX}/user/${uid}/wdl_settings`,
    historyById: (uid: IdType) => `${API_PREFIX}/user/${uid}/actions_log`,
    accountFees: (uid: IdType) => `${API_PREFIX}/users/${uid}/account_fees`,
  },

  accounts: {
    all: `${API_PREFIX}/sub_accounts`,
    search: `${API_PREFIX}/accounts/search`,
    byId: (aid: IdType) => `${API_PREFIX}/accounts/${aid}`,
    updateFee: (aid: IdType) => `${API_PREFIX}/accounts/${aid}/fee`,
  },

  billing: {
    restartPplns: `${API_PREFIX}/billing/recoveryPPLNS`,
    restartPps: `${API_PREFIX}/billing/recoveryPPS`,
    restartRef: `${API_PREFIX}/billing/rerunREF`,
  },

  partnerSchemes: {
    all: `${API_PREFIX}/partnerScheme`,
    users: `${API_PREFIX}/partnerScheme/users`,
    search: `${API_PREFIX}/partnerScheme/search`,
    changeScheme: `${API_PREFIX}/partnerScheme/changeScheme`,
    history: `${API_PREFIX}/partnerSchemeHistory`,
    usersCount: `${API_PREFIX}/partnerScheme/usernumber`,
    byId: (id: IdType) => `${API_PREFIX}/partnerScheme/${id}`,
  },

  recalculation: {
    status: `${API_PREFIX}/billing/task_status`,
    dryRun: `${API_PREFIX}/billing/recalculatedryrun`,
    hardRun: `${API_PREFIX}/billing/recalculation_hard_run `,
  },

  notifications: {
    all: `${API_PREFIX}/announcement`,
  },

  banners: {
    all: `${API_PREFIX}/banner`,
    image: `${API_PREFIX}/banner/img`,
  },
};
